module.exports = __webpack_public_path__ + "static/media/help-24px.60405f42.svg";